import React from "react"

import Carousel from "decentraland-gatsby/dist/components/Carousel/Carousel"
import ImgFixed from "decentraland-gatsby/dist/components/Image/ImgFixed"
import Paragraph from "decentraland-gatsby/dist/components/Text/Paragraph"
import SubTitle from "decentraland-gatsby/dist/components/Text/SubTitle"
import useAsyncMemo from "decentraland-gatsby/dist/hooks/useAsyncMemo"
import Time from "decentraland-gatsby/dist/utils/date/Time"
import TokenList from "decentraland-gatsby/dist/utils/dom/TokenList"

import { getBlogCategories, getBlogposts } from "../../modules/contentful"
import { createBlogPostList } from "../../modules/formats"
import { htmlDecode } from "../../modules/html"
import { slugify } from "../../modules/string"
import LoadingFeed from "./LoadingFeed"
import { FeedProps } from "./types"
import { useFeedColumnName } from "./utils"

import "./BlogFeed.css"
import "./Feed.css"

export type BlogFeedProps = FeedProps

const DEFAULT_COLUMNS = 3

export default React.memo(function BlogFeed(props: BlogFeedProps) {
  const columns = props.columns || DEFAULT_COLUMNS
  const columnClassName = useFeedColumnName(columns, DEFAULT_COLUMNS)

  const [categories] = useAsyncMemo(getBlogCategories)

  const [relatedPosts, relatedPostsState] = useAsyncMemo(
    async () => {
      if (!categories) {
        return false
      }
      const blogpostContent = await getBlogposts({
        offset: 0,
        limit: 3,
      })
      return await createBlogPostList(blogpostContent, categories)
    },
    [categories],
    {
      callWithTruthyDeps: true,
    }
  )

  if (!relatedPostsState.loaded) {
    return <LoadingFeed columns={columns} className="Feed__List" />
  }

  return (
    <Carousel className="Feed BlogFeed">
      <div key={`group::relatedPosts`} className="Feed__List">
        {relatedPosts &&
          relatedPosts.map((post) => {
            const published_at = Time.utc(post.publishedDate)
            return (
              <a
                key={slugify(post.title)}
                className={TokenList.join(["Feed__Item", columnClassName])}
                href={post.url}
                target="_blank"
              >
                <ImgFixed dimension="wide" src={post.image} />
                <div className="Feed__Item__Description">
                  <Paragraph>
                    <span className="Note__Date">
                      {published_at.format("MMM DD")}
                    </span>
                    <span className="Note__Tag">
                      {post.categoryTitle.toUpperCase()}
                    </span>
                  </Paragraph>
                  <SubTitle>{htmlDecode(post.title)}</SubTitle>
                </div>
              </a>
            )
          })}
      </div>
    </Carousel>
  )
})
